function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 25.495,
  y: 6.44936,
  width: 27.2188,
  height: 50.9479,
  rx: 5.23438,
  transform: "rotate(11 25.495 6.44936)",
  stroke: "#0A161F",
  strokeOpacity: 0.2,
  strokeWidth: 2.09375
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.142 32.8033C31.7519 32.9219 32.3579 32.5229 32.4786 31.9017C32.5972 31.2918 32.1859 30.6892 31.5759 30.5707C30.9604 30.451 30.3589 30.8568 30.2404 31.4667C30.1196 32.0878 30.5264 32.6837 31.142 32.8033ZM29.9259 39.0592C30.5359 39.1777 31.1419 38.7787 31.2626 38.1576C31.3812 37.5477 30.9698 36.9451 30.3599 36.8266C29.7444 36.7069 29.1429 37.1126 29.0244 37.7225C28.9036 38.3436 29.3104 38.9395 29.9259 39.0592Z",
  fill: "#737373"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M34.7181 34.9444C34.1721 37.7534 34.4672 40.2381 35.5013 42.5064L37.0345 42.8044C36.2193 41.1129 35.935 37.9451 36.4527 35.2816C36.9694 32.6237 38.4197 29.793 39.8091 28.5301L38.276 28.2321C36.4675 29.9478 35.263 32.141 34.7181 34.9444Z",
  fill: "#737373"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.9583 23.0316C52.9692 23.0316 57.0312 18.9695 57.0312 13.9587C57.0312 8.94783 52.9692 4.88574 47.9583 4.88574C42.9475 4.88574 38.8854 8.94783 38.8854 13.9587C38.8854 18.9695 42.9475 23.0316 47.9583 23.0316Z",
  fill: "#737373"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.9918 9.42188H48.9249L48.7703 15.3936H47.1464L46.9918 9.42188ZM47.9583 18.8814C47.3719 18.8814 46.908 18.4368 46.908 17.8697C46.908 17.3027 47.3719 16.8581 47.9583 16.8581C48.5447 16.8581 49.0087 17.3027 49.0087 17.8697C49.0087 18.4368 48.5447 18.8814 47.9583 18.8814Z",
  fill: "white"
});

function SvgErrorMessageSad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 67,
    viewBox: "0 0 68 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMessageSad);
export default __webpack_public_path__ + "static/media/ErrorMessageSad.f9a3f141.svg";
export { ForwardRef as ReactComponent };